import React, { FC } from 'react'
import { Helmet as ReactHelmet } from 'react-helmet'

import Favicon96 from '../assets/favicons/favicon-96x96.png'
import FaviconSVG from '../assets/favicons/favicon.svg'
import AppleTouchIcon from '../assets/favicons/apple-touch-icon.png'

export const Helmet: FC = () => (
  <ReactHelmet>
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <meta name="theme-color" content="#000000" />
    <link
      rel="apple-touch-icon"
      sizes="180x180"
      href="/assets/apple-touch-icon.png"
    />
    <meta name="description" content="Onboarding Web" />
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1, maximum-scale=1"
    />
    <link
      href="https://fonts.googleapis.com/css2?family=Inter:wght@100;300;400;500;600;700;800&display=swap"
      rel="stylesheet"
    />
    <link
      href="https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap"
      rel="stylesheet"
    />
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" />
    <link
      href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"
      rel="stylesheet"
    />
    <link rel="icon" type="image/png" href={Favicon96} sizes="96x96" />
    <link rel="icon" type="image/svg+xml" href={FaviconSVG} />
    <link rel="apple-touch-icon" sizes="180x180" href={AppleTouchIcon} />

    <title>Sample Bank: Home</title>
  </ReactHelmet>
)
